// Lib
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

// Selectors
import { getPlatformTypeSelector } from '../../platform/platformSelector';

// Types
import { PlatformType } from '../../../common/platform/platformTypes';

/**
 * The context menu event is fired on Android devices when a long press occurs.
 * Because we instead use a long press to drag elements, or start the selection marquee,
 * we need to prevent the default context menu from appearing.
 *
 * Though, we still need the two-finger tap to trigger the context menu, so we need to
 * allow that event to propagate.
 */
export const useAndroidPreventContextMenuEvent = (ref: React.RefObject<HTMLElement>) => {
    const platformType = useSelector(getPlatformTypeSelector);

    useEffect(() => {
        if (!ref.current) return;
        if (platformType !== PlatformType.android) return;

        const abortController = new AbortController();

        ref.current.addEventListener(
            'contextmenu',
            (event) => {
                // If the event is not trusted, it means that it's a custom event - and likely triggered by
                //  the useContextMenuGestureRecognizer. In this case we want the event to propagate & be handled
                if (!event.isTrusted) return;

                event.preventDefault();
                event.stopPropagation();
            },
            { signal: abortController.signal },
        );

        return () => {
            abortController.abort();
        };
    }, [platformType]);
};
